var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.model)?_c('apexchart',{attrs:{"width":"800","type":"bar","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }